import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-合同",
  "use": "icon-合同-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-合同\"><defs><style type=\"text/css\"></style></defs><path d=\"M941.23023 705.115668h-234.707476a88.701603 88.701603 0 0 1-89.005093-87.873906v-0.938057a253.827294 253.827294 0 0 1 73.306426-178.810293 254.158373 254.158373 0 0 0 75.982649-178.920652c1.379496-139.632601-111.54606-255.399919-251.068301-257.358803a254.792941 254.792941 0 0 0-182.452163 436.279455 253.827294 253.827294 0 0 1 73.306426 178.810293v0.938057a88.701603 88.701603 0 0 1-89.005092 87.873906H82.76977a83.018079 83.018079 0 0 0-82.76977 82.769769v118.63667h1024v-118.63667a83.018079 83.018079 0 0 0-82.76977-82.769769z\" fill=\"#8F9AB3\" p-id=\"9354\" /><path d=\"M0 953.011128m34.901253 0l954.197494 0q34.901253 0 34.901253 34.901252l0 0q0 34.901253-34.901253 34.901253l-954.197494 0q-34.901253 0-34.901253-34.901253l0 0q0-34.901253 34.901253-34.901252Z\" fill=\"#8F9AB3\" p-id=\"9355\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/合同.svg
// module id = ZjHM
// module chunks = 75